export const fillFrag = `
precision mediump float;

varying highp vec4 vColor;

void main(void){
    gl_FragColor = vColor;
}
`;
//# sourceMappingURL=fillFrag.js.map